import { mediaUrl } from './BlockRenderer';
import { formatPrice } from '../../lib/format';
import { siteIdentity } from '../../content/siteContent';
import type { CatalogItem } from '../../lib/types';

function summaryText(item: CatalogItem) {
  return item.summary || item.description.slice(0, 160);
}

export function CatalogGrid({ items }: { items: CatalogItem[] }) {
  return (
    <div className="catalog-grid">
      {items.map((item) => (
        <article className="catalog-card" key={item.id}>
          {item.imageId && <img src={mediaUrl(item.imageId)} alt="" loading="lazy" />}
          <h2><a href={`${siteIdentity.catalogPath}/${item.slug}`}>{item.name}</a></h2>
          <p>{summaryText(item)}</p>
          <p className="catalog-card__price">{formatPrice(item.priceCents)}</p>
          <p className="catalog-card__ask">
            <a aria-label={`Ask about ${item.name}`} href={`/contact?type=General&item=${item.slug}`}>Ask about this</a>
          </p>
        </article>
      ))}
    </div>
  );
}
